import FillSymbol from './FillSymbol';
import SymbolFactory from './SymbolFactory';
import GeometryFactory from '../geometry/GeometryFactory';
import GeometryAlgorithm from '../geometry/GeometryAlgorithm';

/**
 * 将点符号绘制在面的中间,只绘制一遍
 */
export default class CenterMarkerFillSymbol extends FillSymbol {
    constructor(options) {
        // 执行父类初始化
        super(options);

        this.marker = null;

        this.type = 'CenterMarkerFillSymbol';

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);

        if (json.marker) {
            const symbolFactory = SymbolFactory.getInstance();
            this.marker = symbolFactory.createSymbol(json.marker);
        }
    }

    toJson() {
        const json = super.toJson();
        if (this.marker) {
            json.marker = this.marker.toJson();
        }

        return json;
    }

    /**
     * 在设备上下文中绘制符号
     * @param {object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * returns {undefined}
     */
    draw(ctx, geometry) {
        if (!this.marker) {
            return;
        }
        if (
            !geometry ||
            !geometry.coordinates ||
            geometry.coordinates.length === 0 ||
            geometry.coordinates[0].length < 3
        ) {
            return;
        }

        this._drawMarker(ctx, geometry);
    }

    /**
     * 将点符号绘制到面的质心位置
     * @param ctx
     */
    _drawMarker(ctx, geometry) {
        const geometryAlgorithm = GeometryAlgorithm.getInstance();
        const geometryFactory = GeometryFactory.getInstance();
        const geojsonPolygon = geometryFactory.toGeojson(geometry);
        const geojsonPoint = geometryAlgorithm.centroid(geojsonPolygon);
        const markerGeom = geometryFactory.fromGeojson(geojsonPoint);
        this.marker.draw(ctx, markerGeom);
    }
}
